import React from 'react';
import {NavLink as Link} from 'react-router-dom';
import _ from 'lodash';
import update from 'immutability-helper';
import BlockEditor from '../../../block-editor/Editor';
import FileAssetField from '../../../contentful/FileAssetField';

class WarrantyDocs extends React.Component {
  constructor(props) {
    super(props);

    this.handlePublish = this.handlePublish.bind(this);
    this.handleUnpublish = this.handleUnpublish.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleAssetChange = this.handleAssetChange.bind(this);
  }

  handleFieldChange(e) {
    const newData = {
      warranty: {}
    };

    newData.warranty[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }

  handleAssetChange(name, asset) {
    const event = {
      target: {
        name: name,
        value: asset
      }
    };

    this.handleFieldChange(event);
  }

  handlePublish(e) {
    e.preventDefault();
    this.props.onPublish();
  }

  handleUnpublish(e) {
    e.preventDefault();
    this.props.onUnpublish();
  }

  handleSave(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  render() {
    const warranty = this.props.warranty;

    const predefinedTags = ['Garantivilkår'];
    if (this.props.make) {
      predefinedTags.push(_.capitalize(this.props.make));
    }

    return (
      <section className="mf-model mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to={`/warranties/${this.props.make}`}>{_.capitalize(this.props.make)}</Link></li>
          <li>Garantivilkår</li>
        </ol>

        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="pull-right">
              {this.props.working &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
              }
              <button
                type="submit"
                className="btn btn-default"
                disabled={!this.props.modified || this.props.working}
              >
                <span>Lagre endringer</span>
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-success"
                disabled={(warranty.published && !warranty.updated) || this.props.working || this.props.modified}
                onClick={this.handlePublish}
              >
                <span>Publiser</span>
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning"
                disabled={warranty.draft || this.props.working}
                onClick={this.handleUnpublish}
              >
                <span>Avpubliser</span>
              </button>
            </div>
            <h1>
              Garantivilkår {/* <PublishStatusDot entry={dealer} /> */}<br />
              <small>{_.capitalize(this.props.make)}</small>
            </h1>
          </div>

          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          <div className="row">
            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Tittel</label>
                <input type="text" className="form-control" name="title" defaultValue={warranty.title} onChange={this.handleFieldChange} disabled={this.props.working} />
              </div>

              {warranty.validFor && warranty.validForOptions &&
                <div className="form-group">
                  <label>Gjelder for</label>
                  <select
                    className="form-control"
                    defaultValue={warranty.validFor}
                    name="validFor"
                    disabled={this.props.working || warranty.archived}
                    onChange={this.handleFieldChange}
                  >
                    {warranty.validForOptions.map((option) => {
                      return (
                        <option
                          key={option}
                          value={option}
                        >
                          {option}
                        </option>
                      );
                    })}
                  </select>
                </div>
              }
            </div>

            <div className="col-xs-12 col-md-6">
              <div className="form-group">
                <label>Fil</label>
                <FileAssetField name="file" value={warranty.file} onChange={this.handleAssetChange} disabled={this.props.working} />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12">
              <div className="form-group" id="bodytext">
                <label>Hovedtekst</label>
                <BlockEditor
                  blocks={warranty.bodytext}
                  onChange={(blocks) => this.handleAssetChange('bodytext', blocks)}
                  disabled={this.props.working || warranty.archived}
                  predefinedTags={predefinedTags}
                />
              </div>
            </div>
          </div>

        </form>
      </section>
    );
  }
}

export default WarrantyDocs;
